import { TextColorType } from "@/lib/main";
import { CSSProperties, HTMLAttributes, PropsWithChildren } from "react";

type Props = PropsWithChildren<{
  className?: HTMLAttributes<HTMLSpanElement>["className"];
  color?: TextColorType;
  fontWeight?: 400 | 500 | 600;
  id?: HTMLAttributes<HTMLSpanElement>["id"];
  lineHeight?: string;
  onClick?: HTMLAttributes<HTMLSpanElement>["onClick"];
  ref?: React.Ref<HTMLSpanElement>;
  size?: "sm" | "md" | "lg" | "caption";
  style?: CSSProperties;
  textAlign?: CSSProperties["textAlign"];
  width?: CSSProperties["width"];
}>;

export default function Span({
  children,
  className,
  color,
  fontWeight,
  id,
  lineHeight,
  onClick,
  ref,
  size,
  style,
  textAlign,
  width,
}: Props) {
  const styles: CSSProperties = {
    color: `var(--color-text-${color || "primary"})`,
    fontSize: !size
      ? "inherit"
      : size === "caption"
        ? "var(--font-size-caption)"
        : `var(--font-size-body-${size})`,
    fontWeight: fontWeight || "inherit",
    lineHeight: lineHeight || "var(--line-height-default)",
    textAlign: textAlign || "start",
    width: width,
    ...style,
  };

  return (
    <span
      className={className}
      id={id}
      onClick={onClick}
      ref={ref}
      style={styles}
    >
      {children}
    </span>
  );
}
